document.addEventListener("DOMContentLoaded", function() {
    // Find modal, background-overlay, body, open button, and close button
    var modal = document.querySelector('.modal');
    var backgroundOverlay = document.querySelector('.background-overlay');
    var closeModalBtn = document.querySelector('.btn-custom-modal-close');
    var body = document.body;
    var modalContent = document.querySelector('.modal-content');
    var modalText = document.querySelector('.modal-content_text');
    var openModalButton = document.querySelector('.btn-modal-open');

    // Function to open the modal
    function openModal() {
        modal.classList.add('show-modal');
        body.classList.add('no-scroll');
    }

    // Function to close the modal
    function closeModal() {
        modal.classList.remove('show-modal');
        body.classList.remove('no-scroll');
    }

    // Event listeners
    if(openModalButton){
        openModalButton.addEventListener('click', openModal);
    }

    if(closeModalBtn){
    closeModalBtn.addEventListener('click', closeModal);
    }

    window.addEventListener('click', function(event) {
        if (event.target === backgroundOverlay) {
            closeModal();
        }
    });
});
